import { render, staticRenderFns } from "./PaymentBankTransferInputs.vue?vue&type=template&id=c4815654&"
import script from "./PaymentBankTransferInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentBankTransferInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports